<script setup lang="ts">
import { UITextMdMedium } from '@gohighlevel/ghl-ui'
import { i18nLocale, useVueI18n } from '../../../locales'
import { ClockRefreshIcon } from '@gohighlevel/ghl-icons/24/outline'
import { UITag } from '@gohighlevel/ghl-ui'
import { formatDateWithLocale } from '../../../utils'

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})
const t = useVueI18n()
</script>

<template>
  <div class="flex items-center justify-between">
    <UITextMdMedium>
      <!-- <span v-if="data?.metaData?.name" class="text-gray-800">
        {{ data.metaData.name }}
        {{ data?.metaData?.email ? `(${data.metaData.email})` : '' }}
      </span>
      <span class="font-bold" v-else> {{ data.metaData.email }} </span> -->
      <span class="text-gray-500">{{
        t('proposalsList.eventLogs.expired')
      }}</span>
    </UITextMdMedium>
  </div>
  <div class="flex justify-between items-end mt-3">
    <p class="text-sm text-gray-500">
      {{
        formatDateWithLocale(
          data.createdAt,
          i18nLocale,
          'MMMM DD, YYYY'
        )
      }}
    </p>
    <UITag type="info" size="small" class="text-[8px] expired-event">
      <template #icon>
        <ClockRefreshIcon class="w-4 h-4 clock-icon"
      /></template>
      {{ t('common.expired') }}
    </UITag>
  </div>
</template>

<style scoped lang="scss">
.expired-event {
  --n-text-color: rgb(239 68 68) !important;
  --n-color: rgb(254 226 226) !important;
  --n-border: 0px !important;
}
.clock-icon {
  color: rgb(239 68 68) !important;
}
</style>
